Ext.define('SA.HistogramExportController', {
    constructor({toolbarButton, modelState, resultPromise}) {
        this.modelState = modelState;

        this.exportController = new SA.ExportController({toolbarButton, contentType: 'chart'});
        this.exportController.on('click:export', this.onClickExport, this);

        resultPromise.then(this.onResult.bind(this));
    },

    async onClickExport({isDownload, fileFormat, emailInfo}) {
        var {modelState, data} = this,
            {viewName, projectName} = modelState,
            viewId = await modelState.idPromise,
            filenameInfo = {viewName, projectName, fileFormat},
            availableSpace = {height: 850, width: 1100},
            chartParams = SA.HistogramChartParams.get({data, modelState, availableSpace}),
            svg = SA.Histogram.build(chartParams);

        SA.Exports.exportChart({viewId, svg, isDownload, filenameInfo, emailInfo});
    },

    onResult(result) {
        if (this.exportController.isDestroyed()) {
            return;
        }

        if (result.hasData()) {
            this.data = result.getData();
            this.exportController.enableForm();
        }

        this.exportController.removeLoadMask();
    }
});